import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import axios from "axios";

export interface Project {
  project: unknown;
}

export interface Devices {
  devices: unknown;
}

export interface Projects {
  project: Project;
  newProjectInfo: Project;
  hasProject: boolean;
  devices: Devices;
  isLoadProject: boolean;
}

@Module
export default class ProjectsModule extends VuexModule implements Projects {
  project = {} as Project;
  devices = {} as Devices;
  newProjectInfo = {} as Project;
  hasProject = true;
  isLoadProject = true;

  /**
   * Get new Project object
   * @returns Project
   */
  get newProject(): Project {
    return this.newProjectInfo;
  }

  /**
   * Get current Project object
   * @returns Project
   */
  get currentProject(): Project {
    return this.project;
  }

  /**
   * Get current Devices object
   * @returns Devices
   */
  get currentDevicesList(): Devices {
    return this.devices;
  }

  /**
   * Load Project
   * @returns object
   */
  get loadProject() {
    return { hasProject: this.hasProject, isLoadProject: this.isLoadProject };
  }

  @Mutation
  [Mutations.SET_NEW_PROJECT](Project) {
    this.newProjectInfo = Project;
  }

  @Mutation
  [Mutations.SET_PROJECT](Project) {
    this.project = Project;
  }

  @Mutation
  [Mutations.LOAD_PROJECTS](info) {
    this.hasProject = info.hasProject;
    this.isLoadProject = info.isLoadProject;
  }

  @Mutation
  [Mutations.SET_DEVICES_OF_PROJECT](Devices) {
    this.devices = Devices;
  }

  @Action
  async [Actions.GET_PROJECTS](params) {
    try {
      const response = await ApiService.get("project" + params);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  [Actions.CHANGE_PROJECT](info) {
    this.context.commit(Mutations.LOAD_PROJECTS, info);
  }

  @Action
  async [Actions.GET_PROJECT_RETRIEVE](id) {
    try {
      const response = await ApiService.get("project/" + id);
      this.context.commit(Mutations.SET_PROJECT, response.data);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.CREATE_PROJECT](data) {
    try {
      const response = await ApiService.post("project", data);
      this.context.commit(Mutations.SET_NEW_PROJECT, response.data);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_DEVICES_OF_PROJECT](info) {
    try {
      const response = await ApiService.get(
        `project/${info.projectId}/devices` + info.params
      );
      this.context.commit(Mutations.SET_DEVICES_OF_PROJECT, response.data);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_DEVICES_DATA_OF_PROJECT](data) {
    try {
      const response = await ApiService.post(`empacloud/device/data`, data);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.DELETE_DEVICE]({ deviceId, projectId }) {
    try {
      const response = await ApiService.delete(
        `project/${projectId}/device/${deviceId}`
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_WS_CONNECTION_KIT](token) {
    try {
      const response = await axios.get(
        process.env.VUE_APP_EMPACLOUD_SDK_SERVICE_URL + "/ws-connection-kit",
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_LIST_APIKEY_DEVICES](apikey) {
    try {
      const response = await axios.get(
        process.env.VUE_APP_EMPACLOUD_SDK_SERVICE_URL +
          "/devices?enabled=1&activated=1",
        {
          headers: {
            Authorization: apikey,
          },
        }
      );
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
